import React, { useContext, useState } from "react";
import { RicosContext } from "./../../ricos-context";
import { getIsModalOpen, useModalState } from "./../../ricos-modals/modal-service-provider";
import { ToggleButton } from "./../../toolbars-ui";
import { HTML_BUTTONS } from "../consts";
const DimensionSliderButton = ({ toolbarItem, dataHook, dimension }) => {
  const [referenceElement, setReferenceElement] = useState(null);
  const { t, isMobile } = useContext(RicosContext) || {};
  const isModalOpen = useModalState(getIsModalOpen(HTML_BUTTONS[dimension]));
  const { icon, tooltip } = toolbarItem.presentation;
  const onClick = () => {
    toolbarItem.commands?.click({ referenceElement, isMobile });
  };
  return /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      setRef: setReferenceElement,
      active: isModalOpen,
      Icon: icon,
      onClick,
      dataHook,
      tooltip: t(tooltip)
    }
  );
};
export {
  DimensionSliderButton
};
//# sourceMappingURL=DimensionSliderButton.js.map
